document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.googleReviews');

    if (container) {
        const observer = new MutationObserver(link_nofollower_mutation_handler);
        observer.observe(container, { childList: true, subtree: true });

        function link_nofollower_mutation_handler(mutations) {
            for (const mutation of mutations) {
                if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                    let review_link = get_link_from_list(mutation.addedNodes);

                    if (review_link) {
                        review_link.rel = 'noopener nofollow';
                        return observer.disconnect();
                    }
                }
            }
        }

        function get_link_from_list(nodes) {
            for (let node of nodes) {
                if (node.nodeName === 'A') {
                    return node;
                } else if (node.querySelectorAll('a').length > 0) {
                    return node.querySelector('a');
                }
            }
        }
    }
});
